import { InputBatch } from '@/models/input-batch';
import { Event } from './event';

export class InputBatchDiscardStartedEvent extends Event<InputBatch> {}
